import React from 'react';
import './StatTimeSpentBox.css';
import LearningHoursGraph from '../LearningHoursGraph/LearningHoursGraph';

export const StatTimeSpentBox = (props) => {
  return (
    <div className="div-block-479 l-h h">
      <div className="div-block-452">
        <div className="skm">Time Spent</div>
      </div>
      <div className="html-embed-12 w-embed w-script">
        {props.timeSpentGraphDataLoaded && (
          <LearningHoursGraph data={props.timeSpentGraphData} />
        )}
      </div>
    </div>
  );
};
